import axios from 'axios'
const urlBase ='https://www.lefisc.com.br/api/lgpd'

export default{
    Apresentacao(){       
        return axios
        .get(`${urlBase}/conteudo/apresentacao`)
        .then(res=> res)   
        .catch(err=> err.response)
    },  
    VisaoGeral(){       
        return axios
        .get(`${urlBase}/conteudo/visao-geral`)
        .then(res=> res)   
        .catch(err=> err.response)
    },  
    Legislacao(){
        return axios
        .get(`${urlBase}/conteudo/legislacao`)
        .then(res=> res)   
        .catch(err=> err.response)
    },
    AplicacaoFederal(){
        return axios
        .get(`${urlBase}/conteudo/aplicacao-federal`)
        .then(res=> res)   
        .catch(err=> err.response)
    },
    AplicacaoTrabalhista(){
        return axios
        .get(`${urlBase}/conteudo/aplicacao-trabalhista`)
        .then(res=> res)   
        .catch(err=> err.response)
    }
    
}